import * as React from 'react';
import { formatText } from 'bernie-l10n';
import { UitkRemovablePill } from 'uitk-react-pill';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { Viewport, ViewLarge, ViewSmall } from 'bernie-view';
import { UitkSpacing } from 'uitk-react-spacing';
import { ActivityDestinationViewSearch } from '../../../common/__generated__/api';
import { handlePillsClick } from '../../../helpers/activity-search-helper';

import { useStores } from '../../../utils/hooks';
import { getPageId } from '../../../helpers/common-helper';

export const FilterPills: React.FC<{}> = (): JSX.Element | null => {
  const { activitySearchStore, analytics, routeStore } = useStores();

  const pageId = getPageId(activitySearchStore);
  const { searchSummary } = activitySearchStore;

  const pills = searchSummary?.aboveTheFold?.pills;

  if (!pills || pills.length < 1) {
    return null;
  }

  const Pills: React.FC = (): JSX.Element =>
    pills.map((pill: ActivityDestinationViewSearch.Pills, index: number) => (
      <UitkLayoutFlexItem key={`pill-${index}`}>
        <div data-testid="filter-pill">
          <UitkRemovablePill
            id={`pill-${index}`}
            disabled={false}
            onClick={(): void => handlePillsClick(routeStore, pill.selections || [], pageId, analytics)}
            altText={formatText('lx.pills.remove.accessibility.text', pill.label)}
          >
            <span aria-hidden="true">{pill.label}</span>
          </UitkRemovablePill>
        </div>
      </UitkLayoutFlexItem>
    ));

  return (
    <Viewport>
      <ViewSmall>
        <UitkSpacing margin={{ block: 'three' }} padding={{ inline: 'three' }}>
          <UitkLayoutFlex className="uitk-scroll-horizontal" space="two">
            <Pills />
          </UitkLayoutFlex>
        </UitkSpacing>
      </ViewSmall>
      <ViewLarge>
        <UitkSpacing margin={{ block: 'three' }} padding={{ inline: 'three' }}>
          <UitkLayoutFlex space="two" wrap="wrap">
            <Pills />
          </UitkLayoutFlex>
        </UitkSpacing>
      </ViewLarge>
    </Viewport>
  );
};
